module.exports = __webpack_public_path__ + "static/media/chess-queen.1d2e4929.svg";